import type { FaireProductEntity } from "../../entity_types/product";

export const p_dnxmt2u436: FaireProductEntity = {
  token: "p_dnxmt2u436",
  type: "product",
  name: "Topical Magnesium Oil Spray",
  brandToken: "b_9lnqwiw9kl",
  brandName: "Cymbiotika",
  imageUrl:
    "https://cdn.faire.com/fastly/bedec578176e1236f29c7110f72697aac7b30f1214e8af27f129bc87461ffbf7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4f2f866e7a8373c2f2c78e82158cdeaed649097ab5bf2ab7cfc7c12842a45b3.jpeg",
    "https://cdn.faire.com/fastly/d90376c4ed230618585bd51ab661b568ac3385e5b01643018420829c34af191a.jpeg",
    "https://cdn.faire.com/fastly/e65a091beaec74edd54ebd906d38d5b5be67fc1b839f3ab83bde17e026837bbc.jpeg",
  ],
  priceDollars: 27.44,
  description:
    "Cymbiotika’s Topical Magnesium Oil spray is scientifically formulated to absorb into the bloodstream within minutes, keeping your skin free of oil residue. Magnesium is an essential trace mineral responsible for more than 300 enzymatic systems that regulate diverse biochemical reactions in the body, including muscle and nerve function, blood glucose control, blood pressure regulation, and healthy brain development. Prolonged magnesium deficiency can impact your long-term health and since our bodies cannot produce enough magnesium on its own, magnesium supplementation is the most effective way to elevate magnesium levels. \n\n15-20 sprays twice a day*\nSpray and rub onto clean skin of the torso, chest, feet, legs, or arms.  Avoid sensitive areas.  Avoid contact with clothing, or other lotions until absorbed.\nStore in a cool, dry place away from direct sunlight.",
  tags: [],
  msrpDollars: 49.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:32.434Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
